import { Component, OnInit } from '@angular/core';
@Component({
  selector: 'app-our-services',
  templateUrl: './our-services.component.html',
  styleUrls: ['./our-services.component.scss'],
})
export class OurServicesComponent implements OnInit {
  responsiveOptions;
  services = [
    {
      title: 'Atención médica por COVID-19',
      content:
        'Te cubrimos los gastos por atención médica para tu diagnóstico, tratamiento, gastos de traslado y repatriación sanitaria en consecuencia de adquirir COVID-19.',
      img: 'https://res.cloudinary.com/pervolare-org/image/upload/q_auto/f_auto/v1776215296/TAS/home/Property-1_Default_uup1nv.webp',
    },
    {
      title: 'Hospitalización',
      content:
        'Una protección integral enfocada en ti. Cubrimos todos los aspectos en tu hospitalización, ya sea por enfermedad, accidente o cualquier otro motivo que te impida continuar tu viaje.',
      img: 'https://res.cloudinary.com/pervolare-org/image/upload/q_auto/f_auto/v1776215296/TAS/home/Property-1_Default_1__wwqd30.webp',
    },
    {
      title: 'Asistencia médica por accidente o enfermedad',
      content:
        'Disfruta tu viaje sin preocupaciones, te brindamos la mejor atención médica especializada, ya sea por accidente o enfermedad.',
      img: 'https://res.cloudinary.com/pervolare-org/image/upload/q_auto/f_auto/v1776215295/TAS/home/Property-1_Default_2__l1gme5.webp',
    },
    {
      title: 'Cancelación de vuelo',
      content: 'Si cancelan tu vuelo, te reembolsamos los gastos derivados por consecuencia de esta situación. ',
      img: 'https://res.cloudinary.com/pervolare-org/image/upload/q_auto/f_auto/v1776215295/TAS/home/Property-1_Default_3__zqex9o.webp',
    },
    {
      title: 'Telemedicina y video consulta',
      content:
        'Estamos disponibles 24/7 en caso de emergencia, podremos anticipar el diagnóstico junto con sus síntomas y brindarte soluciones para tratarlos.',
      img: 'https://res.cloudinary.com/pervolare-org/image/upload/q_auto/f_auto/v1776215296/TAS/home/Property-1_Default_4__eeqmsx.webp',
    },
    {
      title: 'Repatriación sanitaria',
      content:
        'Te ofrecemos este servicio en caso de que una enfermedad grave te impida continuar con tu viaje, te cubrimos en caso de que necesites regresar de urgencia a tu país.',
      img: 'https://res.cloudinary.com/pervolare-org/image/upload/q_auto/f_auto/v1776215295/TAS/home/Property-1_Default_5__emagxo.webp',
    },
  ];
  constructor() {
    this.responsiveOptions = [
      {
        breakpoint: '1460px',
        numVisible: 3,
        numScroll: 1,
      },
      {
        breakpoint: '1366px',
        numVisible: 3,
        numScroll: 1,
      },
      {
        breakpoint: '1100px',
        numVisible: 2,
        numScroll: 1,
      },
      {
        breakpoint: '560px',
        numVisible: 1,
        numScroll: 1,
        showNavigators: true,
        showIndicators: true,
      },
    ];
  }

  ngOnInit(): void {}
}
